export default __webpack_public_path__ + "static/home_hero_image_tablet-7043b8428f500b8f601d2efb8b8ccbef.png";